import React from "react";
import SeoLanding from "./SeoLanding";

export default function CoursDeJaponais() {
  return (
    <SeoLanding
      testid="seo-cours"
      title="Cours de japonais en ligne | Japonais Pas à Pas : Essai gratuit 3 jours"
      description="Cours de japonais en ligne 100% en français pour débutants à intermédiaires. 200 leçons N5 → N3, tuteur IA, audio natif. Essai gratuit 3 jours, sans carte bancaire."
      keywords="cours de japonais, cours de japonais en ligne, cours japonais débutant, cours de japonais français, cours particulier japonais, prendre des cours de japonais, JLPT N5"
      canonical="https://japonais-pas-a-pas.com/cours-de-japonais"
      h1="Cours de japonais en ligne, la méthode joyeuse pour francophones"
      subtitle="Des cours de japonais structurés, accessibles 24/7, avec un vrai tuteur IA. Du JLPT N5 au N3."
      lead="Vous cherchez des cours de japonais en ligne sans manuel rébarbatif et sans engagement ? Japonais Pas à Pas propose 200 leçons interactives en français, conçues par une équipe franco-japonaise. Que vous soyez grand débutant ou intermédiaire en quête de progression, nos cours de japonais s'adaptent à votre rythme : 15 minutes par jour suffisent."
      sections={[
        {
          h2: "Pourquoi prendre des cours de japonais avec nous ?",
          paragraphs: [
            "La majorité des francophones qui démarrent des <strong>cours de japonais</strong> traditionnels abandonnent en moins de 3 mois : manque de temps, contenus trop académiques, absence de suivi. Notre plateforme casse ce schéma avec une approche micro-learning : des leçons courtes, des quiz immédiats, et un tuteur IA qui répond à vos questions à toute heure.",
            "Nos <strong>cours de japonais</strong> couvrent l'intégralité du programme JLPT N5, N4 et N3 : hiragana, katakana, kanji, grammaire, conversation, écoute. Chaque leçon est livrée avec un audio natif enregistré par nos voix japonaises Atsuko (féminine) et Alexis (masculine), finie l'horreur des voix robotiques qui prononcent les kanji en chinois.",
          ],
          bullets: [
            "<strong>Cours structurés</strong> : parcours linéaire du débutant absolu au niveau intermédiaire confortable",
            "<strong>Audio natif japonais</strong> : Atsuko & Alexis prononcent chaque mot, chaque dialogue, chaque exemple",
            "<strong>Tuteur IA en français</strong> : pose tes questions à 23h, il répond. Mieux qu'un prof particulier, infiniment moins cher",
            "<strong>Système de révision intelligente</strong> : tu ne révises que ce que ton cerveau s'apprête à oublier",
            "<strong>Examens blancs JLPT</strong> chronométrés pour t'entraîner aux vraies conditions des tests officiels",
            "<strong>Essai gratuit 3 jours</strong>, sans carte bancaire, sans engagement",
          ],
        },
        {
          h2: "Cours de japonais débutant : par où commencer ?",
          paragraphs: [
            "Si tu démarres de zéro, ne te disperse pas. Notre parcours commence par les <strong>hiragana</strong> (les 46 caractères de base) : tu les maîtrises en 5 à 7 jours grâce à notre tableau interactif avec audio. Ensuite viennent les katakana (1 semaine), puis les premiers kanji et la grammaire de base (politesses, verbes être/avoir, particules).",
            "À la fin du premier mois, tu peux déjà te présenter en japonais, lire des kana, et comprendre des phrases simples. C'est exactement ce que recherchent les vrais débutants quand ils tapent « <strong>cours de japonais débutant</strong> » sur Google : du concret, du progressif, et un sentiment de victoire chaque semaine.",
          ],
        },
        {
          h2: "Cours de japonais en ligne vs cours particuliers : que choisir ?",
          paragraphs: [
            "Les <strong>cours de japonais en ligne</strong> ont 3 avantages majeurs sur les cours particuliers :",
          ],
          bullets: [
            "<strong>Le prix</strong> : 12,90 €/mois chez Japonais Pas à Pas vs 30-60 €/heure pour un prof particulier",
            "<strong>La flexibilité</strong> : tu apprends quand tu veux, où tu veux, sans rendez-vous à caler",
            "<strong>Le contenu structuré</strong> : un parcours linéaire vs des cours souvent improvisés selon l'humeur du prof",
          ],
        },
        {
          h2: "Combien coûtent nos cours de japonais ?",
          paragraphs: [
            "Trois formules au choix après l'essai gratuit de 3 jours : <strong>12,90 €/mois</strong> en mensuel, <strong>89 €/an</strong> en annuel (43% moins cher), ou <strong>199 €</strong> à vie. Nous proposons aussi une offre Fondateur à 49 € à vie pour les 100 premiers étudiants, c'est le bon moment d'en faire partie.",
            "Tous les plans donnent accès à 100% du contenu : 200 leçons, 636 mots de vocabulaire, tuteur IA illimité, examens blancs JLPT, audio natif, et toutes les futures mises à jour.",
          ],
        },
      ]}
      faq={[
        {
          q: "Combien de temps pour atteindre un niveau correct avec ces cours de japonais ?",
          a: "Avec 15 minutes par jour, comptez 3 mois pour le JLPT N5 (vous présenter, conversations simples), 9-12 mois pour le N4, et 1,5 à 2 ans pour le N3.",
        },
        {
          q: "Faut-il un niveau préalable pour commencer ?",
          a: "Absolument pas. Nos cours de japonais démarrent à zéro : ni hiragana ni katakana requis. Un test de placement de 10 questions au signup vous oriente automatiquement vers le bon niveau.",
        },
        {
          q: "Puis-je essayer avant de payer ?",
          a: "Oui, essai gratuit 3 jours sans carte bancaire. Vous accédez à toutes les leçons N5, au tuteur IA et au vocabulaire de base. Si la méthode ne vous plaît pas, vous partez sans rien payer.",
        },
        {
          q: "Les cours de japonais incluent-ils un suivi personnalisé ?",
          a: "Oui : tableau de progression personnalisé, système de révision intelligente qui s'adapte à votre mémoire, et tuteur IA disponible 24/7 qui répond à vos questions en français.",
        },
        {
          q: "Puis-je résilier mon abonnement à tout moment ?",
          a: "Oui, sans frais ni pénalité. Tu gardes l'accès jusqu'à la fin de la période payée puis l'abonnement s'arrête. Aucune réactivation automatique.",
        },
      ]}
    />
  );
}
